import { z } from 'zod';
import { RESERVED_DISPLAY_NAMES } from './constants.ts';
import { EMAIL_SCHEMA } from '@monocle-money/zod-schema';

const displayName = z
  .string()
  .refine(
    (value) => (
      !RESERVED_DISPLAY_NAMES.includes(value)
    ),
    { message: 'This display name is reserved.' }
  );
export const POST_SCHEMA = z.object({
  displayName,
  email: EMAIL_SCHEMA,
});

export const PATCH_SCHEMA = z.object({
  displayName: displayName.optional(),
  gameId: z.number().optional().nullable(), // null removes user from game
});